import React from 'react';
import { TooltipProps } from '@material-ui/core/Tooltip/Tooltip';
import { Tooltip } from '@material-ui/core';

interface Props extends TooltipProps {
  children: React.ReactElement;
  enabled?: boolean;
}

export const WithTooltip: React.FC<Props> = ({ children, enabled, ...props }: Props) =>
  enabled && children ? <Tooltip {...props}>{children}</Tooltip> : <>{children}</>;
